<template></template>
<script>
import { ws, yunxiangHost } from "@/utils/config";

import { mapGetters, mapActions, mapMutations } from "vuex";
import { getflightplanbysn } from "@/request/api";

import AircraftInfo from "./keepWatch/aircraftInfo";
import ourmap from "./keepWatch/ourMap";
import drawLayer from "@/mixin/drawLayer";

var ourMap;

export default {
  mixins: [drawLayer],
  data() {
    return {
      socket: null, //socket实例
      adDataList: [],

      //心跳包
      timeout: 1000 * 60,
      timeoutObj: null, //心跳定时器

      AircraftList: null,
      timer: null, //闪烁定时器
      IconTimer: null,

      localIcaoArr: [],
      turnCraftList: [], //直升机数组
      lightCraftList: [], //轻型设备
      currentAlarmArr: [], //当前告警数值
      aircraftInfos: [], //所有飞机实例
      allAircraftDistanceAlarms: [],
      allAircraftZoneAlarms: [],
      allAircraftFlightAlarms: [],

      showAircraft: true,
      showStation: true,
    };
  },
  mounted() {

    this.$eventBus.$on("switchAdsbData", async (e) => {
      if (this.socket) {
        await this.closeWebsocket();
        await this.openAdsbData();
      } else {
        this.openAdsbData();
      }
    });

    this.openAdsbData();

    this.$eventBus.$on("openAdsbData", (e) => {
      this.openAdsbData();
    });
    this.$eventBus.$on("closeWebsocket", (e) => {
      this.closeWebsocket();
    });

    this.$eventBus.$on("hideAllAircraft", (e) => {
      this.hideAllAircraft();
    });
    this.$eventBus.$off("showAllAircraft");
    this.$eventBus.$on("showAllAircraft", (e) => {
      this.showAllAircraft();
    });
  },
  beforeDestroy() {
    this.closeWebsocket();

    this.$eventBus.$off("switchAdsbData");
    this.$eventBus.$off("closeWebsocket");
    this.$eventBus.$off("openAdsbData");
    this.$eventBus.$off("hideAllAircraft");
    this.$eventBus.$off("showAllStation");
    this.$eventBus.$off("hideAllStation");
  },
  watch: {
    alarmHeight(val) {
      //重设高度,立即响应
      this.aircraftInfos.forEach((aircraftInfo) => {
        if (!aircraftInfo.isStation) {
          if (
            Number(aircraftInfo.airLocationInfo.alAltitude) >= val[0] &&
            Number(aircraftInfo.airLocationInfo.alAltitude) <= val[1]
          ) {
            aircraftInfo.currentHeight = true;
          } else {
            aircraftInfo.currentHeight = false;
          }
          let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
          ourMap.setHeightMarker(marker, aircraftInfo);
        }
      });
    },

    watchAir(val) {
      //分类
      this.aircraftInfos.forEach((aircraftInfo) => {
        if (!aircraftInfo.isStation) {
          let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
          ourMap.setTypeMarker(marker, aircraftInfo, val);
        }
      });
    },
  },

  computed: {
    ...mapGetters({
      adsbMap: "meteorologicalMap/adsbMap",
      meteoToken: "meteoToken",
      userId: "userId",
      type: "type",
      currentMap: "switchMap/currentMap",
      alarmHeight: "swichLayer/alarmHeight",
      watchAir: "swichLayer/watchAir",
    }),
  },
  methods: {
    ...mapActions({
      startDataDrawAction: "drawMap/startDataDrawAction",
      stopDrawAction: "drawMap/stopDrawAction",
    }),
    ...mapMutations({
      changeTransportNowList: "swichLayer/changeTransportNowList",
      changeAirNowList: "swichLayer/changeAirNowList",
      changeGeneralNowList: "swichLayer/changeGeneralNowList",
      initPlanshow: "swichLayer/initPlanshow",
      changeshowPlanInfo: "swichLayer/changeshowPlanInfo",
      changeshowFunMeunBar: "swichLayer/changeshowFunMeunBar",
      changeshowFunMeunBarFLag: "swichLayer/changeshowFunMeunBarFLag",
      changeAlarmNowList: "swichLayer/changeAlarmNowList",
      changeshowMapMeunBarFlag: "swichLayer/changeshowMapMeunBarFlag",
      changeinitPosition: "swichLayer/changeinitPosition",
      changeAircraftInfosList: "swichLayer/changeAircraftInfosList",
    }),

    closeMapClick() {
      map.off("zoomend", (e) => {
        if (ourMap) {
          ourMap.setLabelPosition();
        }
      });

      map.off("click", () => {
        this.changeshowFunMeunBarFLag(false);
        this.changeshowMapMeunBarFlag(false);
        this.aircraftInfos.forEach((aircraftInfo) => {
          if (aircraftInfo.isShowUnCurrentHeightLabel) {
            aircraftInfo.isShowUnCurrentHeightLabel = false;
            aircraftInfo.disappearLabel(aircraftInfo.icao);
          }
        });
      });
      map.off("contextmenu", (e) => {
        if (ourMap.openRanging) {
          return;
        }
        this.changeinitPosition(e.latlng);
        if (this.$route.path == "/index/runcontrol") {
          this.changeshowMapMeunBarFlag(false);
          setTimeout(() => {
            this.changeshowMapMeunBarFlag(true);
          }, 100);
        }
      });
    },
    openMapClick() {
      map.on("zoomend", (e) => {
        if (ourMap) {
          ourMap.setLabelPosition();
        }
      });

      map.on("click", () => {
        this.changeshowFunMeunBarFLag(false);
        this.changeshowMapMeunBarFlag(false);
        this.aircraftInfos.forEach((aircraftInfo) => {
          if (aircraftInfo.isShowUnCurrentHeightLabel) {
            aircraftInfo.isShowUnCurrentHeightLabel = false;
            aircraftInfo.disappearLabel(aircraftInfo.icao);
          }
        });
      });
      map.on("contextmenu", (e) => {
        if (ourMap.openRanging) {
          return;
        }
        this.changeinitPosition(e.latlng);
        if (this.$route.path == "/index/runcontrol") {
          this.changeshowMapMeunBarFlag(false);
          setTimeout(() => {
            this.changeshowMapMeunBarFlag(true);
          }, 100);
        }
      });
    },
    // adsb
    openAdsbData() {
      ourMap = new ourmap();
      ourMap.initOurMap({
        adsbMap: this.adsbMap,
        showPlan: this.showPlan,
        aircraftInfos: this.aircraftInfos,
        vm: this,
      });
      window.ourMap = ourMap;

      this.openWebsocket();
      this.setAlarmInterval();
      this.setIconInterval();

      this.openMapClick();

      if (ourMap) {
        // 测距事件相关
        map.on("mousemove", function (event) {
          if (ourMap.openRanging) {
            if (ourMap.isStartMove) {
              var postion = { ...ourMap.latePoint };
              ourMap.drawRangePolyline([
                { la: postion.la, lo: postion.lo },
                { la: event.latlng.lat, lo: event.latlng.lng },
              ]);
              ourMap.isEndMove = true;
            }
          }
        });

        map.on("contextmenu", function (event) {
          if (ourMap.openRanging) {
            if (ourMap.isStartMove) {
              ourMap.num++;
            } else {
              ourMap.num = 0;
            }

            var postion = {
              index: ourMap.num,
              hasIcao: false,
              icao: null,
              la: event.latlng.lat,
              lo: event.latlng.lng,
            };

            if (ourMap.latePoint) {
              if (ourMap.latePoint.index < postion.index) {
                ourMap.showDistance([ourMap.latePoint, postion]);

                ourMap.addRangePolyline([ourMap.latePoint, postion]);
              }
            }

            ourMap.points.push(postion);
            ourMap.latePoint = { ...postion };
            ourMap.isStartMove = true;

            var circleMarker = L.circleMarker(
              [event.latlng.lat, event.latlng.lng],
              {
                radius: 5,
                color: "#90ee90",
                opacity: 1,
              }
            ).addTo(map);
            circleMarker.clickNum = ourMap.clickNum;
            ourMap.MarkerPoints.push(circleMarker);
          }
        });

        map.on("click", (event) => {
          if (ourMap.openRanging) {
            if (!ourMap.isStartMove) {
              return;
            }
            if (ourMap.isEndMove) {
              ourMap.num++;
              var postion = {
                index: ourMap.num,
                hasIcao: false,
                icao: null,
                la: event.latlng.lat,
                lo: event.latlng.lng,
              };

              if (ourMap.latePoint) {
                if (ourMap.latePoint.index < postion.index) {
                  ourMap.showDistance([ourMap.latePoint, postion]);
                  ourMap.addRangePolyline([ourMap.latePoint, postion]);
                  ourMap.points.push(postion);
                }
              }
            }

            ourMap.isStartMove = false;
            ourMap.isEndMove = false;
            ourMap.latePoint = null;

            var circleMarker = L.circleMarker(
              [event.latlng.lat, event.latlng.lng],
              {
                radius: 5,
                color: "#90ee90",
                opacity: 1,
              }
            ).addTo(map);

            circleMarker.clickNum = ourMap.clickNum;
            ourMap.MarkerPoints.push(circleMarker);

            ourMap.clickNum++;

            let arr = [
              ...ourMap.MarkerPoints,
              ...ourMap.calculatDistanceMarks,
              ...ourMap.calculatDistanceLines,
            ];

            let dataSort = [];
            arr.forEach((obj) => {
              let array = dataSort[obj["clickNum"]] || [];
              array.push(obj);
              dataSort[obj["clickNum"]] = array;
            });

            var measureAction = new L.MeasureAction(map, {
              model: "area", // 'area' or 'distance', default is 'distance'
            });

            measureAction.enable();
            measureAction._addLable(
              [event.latlng.lat, event.latlng.lng],
              "",
              "leaflet-measure-lable",
              true,
              dataSort[dataSort.length - 1]
            );

            measureAction.disable();
          }
        });
      }
    },

    closeWebsocket() {
      if (this.socket && this.socket.readyState == 1) {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.errorTime);
        this.socket.close();

        this.timer && clearInterval(this.timer);
        this.IconTimer && clearInterval(this.IconTimer);
        this.aircraftInfos = [];
        window.ourMap = null;
        this.adsbMap.iconGroup.clearLayers(); //飞机清空
        this.adsbMap.stationGroup.clearLayers(); //静态基站清空
        this.closeMapClick();
      }
    },

    //打开adsb数据入口
    async openWebsocket() {
      if (this.socket && socket.readyState == 1) {
        return;
      }
      this.socket = new WebSocket(
        ws + `${this.userId}_${this.type}_` + new Date().getTime()
      );
      this.localIcaoArr = await this.getLocalXml();

      this.showStation = false;
      // ourMap.createAllGroundBase(); //渲染静态基站

      this.socket.onmessage = (e) => {
        this.adDataList = JSON.parse(e.data);
        this.initWsData();
        this.adDataList.createTime = Date.now();
      };

      this.socket.onopen = () => {
        this.start(); //心跳检测开始
      };
    },
    start() {
      this.timeoutObj = setTimeout(() => {
        let nowTime = Date.now();
        if (nowTime - this.adDataList.createTime > 3000) {
          clearTimeout(this.timeoutObj);
          this.socket.close();
          this.openWebsocket();
        } else {
          clearTimeout(this.timeoutObj);
          this.start();
        }
      }, this.timeout);
    },

    getLocalXml() {
      return new Promise((resolve, reject) => {
        let arr = [];
        let xhr = new XMLHttpRequest();
        xhr.open("GET", "/static/xml/planeInfo.xml", false);
        xhr.onload = (res) => {
          let xmlDoc = res.currentTarget.responseXML;
          let objNodeList = xmlDoc.querySelectorAll("SelfPlane PlaneInfo");

          objNodeList.forEach((dom) => {
            arr.push({
              sn: dom.attributes.flight.value,
              AACode: dom.attributes.AACode.value,
              company: dom.lastElementChild.attributes.company.value,
              icon: dom.firstElementChild.attributes.icon.value,
              devicetype: dom.lastElementChild.attributes.model.value,
            });
          });
          resolve(arr);
        };
        xhr.send();
      });
    },

    initWsData() {
      let msg = this.adDataList;
      //init
      let aircraftCompleteMsgList = [];
      //去除信标
      msg.aircraftCompleteMsgList.forEach((item, index) => {
        if (
          item.icao == "fff117" ||
          item.icao == "000209" ||
          item.icao == "000211" ||
          item.icao == "ec0999" ||
          item.icao == "ec0998" ||
          item.icao == "ec0997" ||
          item.icao == "ec0996" ||
          item.icao == "ec0991" ||
          item.icao == "ec0989" ||
          item.icao == "ec2985" ||
          item.icao == "ec2983" ||
          item.icao == "ec2986" ||
          item.icao == "ec2995" ||
          item.icao == "000210" ||
          item.icao == "000207" ||
          item.icao == "000208" ||
          item.icao == "121023"
        ) {
          return;
        } else {
          aircraftCompleteMsgList.push(item);
        }
      });

      aircraftCompleteMsgList.forEach((aircraftCompleteMsg, index) => {
        var aircraftInfoIndex = this.getAircraftInfoIndex(
          aircraftCompleteMsg.icao
        );

        if (aircraftInfoIndex != -1) {
          //地图上已有
          var aircraftInfo = this.aircraftInfos[aircraftInfoIndex];

          if (!aircraftInfo.showAircraftFlag) {
            return;
          }

          //重新赋值
          aircraftInfo.alarmHeight = this.alarmHeight;
          aircraftInfo.watchAir = this.watchAir;

          aircraftInfo.setNewValue(aircraftCompleteMsg);

          if (aircraftInfo.airLocationInfo.geometricHeightEffective) {
            if (
              Number(aircraftInfo.airLocationInfo.geometricHeight) >=
                aircraftInfo.alarmHeight[0] &&
              Number(aircraftInfo.airLocationInfo.geometricHeight) <=
                aircraftInfo.alarmHeight[1]
            ) {
              aircraftInfo.currentHeight = true;
            } else {
              aircraftInfo.currentHeight = false;
            }
          } else {
            if (
              Number(aircraftInfo.airLocationInfo.alAltitude) >=
                aircraftInfo.alarmHeight[0] &&
              Number(aircraftInfo.airLocationInfo.alAltitude) <=
                aircraftInfo.alarmHeight[1]
            ) {
              aircraftInfo.currentHeight = true;
            } else {
              aircraftInfo.currentHeight = false;
            }
          }
          if (!aircraftInfo.isStation) {
            aircraftInfo.changeLocation();

            if (
              aircraftInfo.isShowLabel ||
              aircraftInfo.isShowUnCurrentHeightLabel
            ) {
              aircraftInfo.setAircraftLabel();
            }

            //筛选机制
            // 改变高度
            let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
            ourMap.setHeightMarker(marker, aircraftInfo);
            // 改变类型

            ourMap.setTypeMarker(marker, aircraftInfo, this.watchAir);
          }

          //轨迹线
          if (ourMap.getOneLocusLinePolyIndex(aircraftInfo) != -1) {
            aircraftInfo.addLocus();
          }
          //尾迹线
          if (ourMap.getOneWakeLinePolyIndex(aircraftInfo) != -1) {
            aircraftInfo.addWake();
          }
          //关注
          if (aircraftInfo.isFollow == true) {
            aircraftInfo.addFollow();
          }
          //预计线
          if (ourMap.getOnePredictLinePolyIndex(aircraftInfo) != -1) {
            aircraftInfo.showDarwPredictLine();
          }
          //测距
          if (ourMap.getOneCalculatDistanceLineIndex() != -1) {
            ourMap.redrawRangePolyline();
            ourMap.updateDistance();
            ourMap.redrawMarkerPoint();
          }
        } else {
          // 初始化
          var newAircraftInfo = new AircraftInfo(aircraftCompleteMsg);
          this.aircraftInfos.push(newAircraftInfo);
          newAircraftInfo.alarmHeight = this.alarmHeight;
          newAircraftInfo.watchAir = this.watchAir;

          if (newAircraftInfo.airLocationInfo.geometricHeightEffective) {
            if (
              Number(newAircraftInfo.airLocationInfo.geometricHeight) >=
                newAircraftInfo.alarmHeight[0] &&
              Number(newAircraftInfo.airLocationInfo.geometricHeight) <=
                newAircraftInfo.alarmHeight[1]
            ) {
              newAircraftInfo.currentHeight = true;
            } else {
              newAircraftInfo.currentHeight = false;
            }
          } else {
            if (
              Number(newAircraftInfo.airLocationInfo.alAltitude) >=
                newAircraftInfo.alarmHeight[0] &&
              Number(newAircraftInfo.airLocationInfo.alAltitude) <=
                newAircraftInfo.alarmHeight[1]
            ) {
              newAircraftInfo.currentHeight = true;
            } else {
              newAircraftInfo.currentHeight = false;
            }
          }

          if (!newAircraftInfo.isStation) {
            newAircraftInfo.dargxyCollision(this.aircraftInfos);
          }

          newAircraftInfo.appear(aircraftCompleteMsg);
        }
      });

      // 航空器分类数量
      this.AircraftList = [];
      this.AircraftOtherList = [];
      this.MyAircraftList = [];

      //筛选高度后的飞机
      this.AircraftList = this.aircraftInfos.filter((item) => {
        return item.currentHeight === true && item.isStation === false;
      });

      //他航

      //我航
      // this.MyAircraftList = this.AircraftList.filter((item) => {
      //   return item.partOfGeneralCompany === true;
      // });

      this.AircraftOtherList = this.aircraftInfos.filter((item) => {
        return (
          item.partOfGeneralCompany === false &&
          item.currentHeight === true &&
          item.isStation === false
        );
      });

      this.MyAircraftList = this.aircraftInfos.filter((item) => {
        return (
          item.partOfGeneralCompany === true &&
          item.currentHeight === true &&
          item.isStation === false
        );
      });

      this.changeTransportNowList(this.AircraftOtherList);
      this.changeAirNowList(this.AircraftList);
      this.changeGeneralNowList(this.MyAircraftList);
      this.changeAircraftInfosList(this.aircraftInfos);

      this.changeAlarmNowList({
        alarmDisappearList: this.adDataList.alarmDisappearList,
        alarmDistanceList: this.adDataList.alarmDistanceList,
        alarmYawList: this.adDataList.alarmYawList,
        alarmZoneList: this.adDataList.alarmZoneList,
      });

      if (this.showAircraft) {
        this.turnCraftListFun(); //直升机
        this.lightCraftListFun(); //轻型设备
        this.alarmCraftList(msg); //告警
        this.clearCraftList(msg); //清除大于7秒飞机
      }
    },

    hideAllAircraft() {
      this.showAircraft = false;
      this.timer && clearInterval(this.timer);
      this.aircraftInfos.forEach((AircraftInfo) => {
        if (!AircraftInfo.isStation) {
          AircraftInfo.hideAircraft();
        }
      });
    },

    showAllAircraft() {
      this.showAircraft = true;
      this.setAlarmInterval();
      this.aircraftInfos.forEach((AircraftInfo) => {
        if (!AircraftInfo.isStation) {
          AircraftInfo.showAircraft();
        }
      });
    },

    showAllStation() {
      ourMap.showGroundBase();
      this.aircraftInfos.forEach((AircraftInfo) => {
        if (AircraftInfo.isStation) {
          AircraftInfo.showStation();
        }
      });
    },

    hideAllStation() {
      ourMap.hideGroundBase();
      this.aircraftInfos.forEach((AircraftInfo) => {
        if (AircraftInfo.isStation) {
          AircraftInfo.hideStation();
        }
      });
    },

    getAircraftInfoIndex(icao) {
      var aircraftInGeInfoCenter = this;
      for (var i = 0; i < aircraftInGeInfoCenter.aircraftInfos.length; i++) {
        var aircraftInfo = aircraftInGeInfoCenter.aircraftInfos[i];
        if (aircraftInfo.icao == icao) {
          return i;
        }
      }
      return -1;
    },

    turnCraftListFun() {
      this.turnCraftList = [];
      this.aircraftInfos.forEach((AircraftInfo) => {
        if (AircraftInfo.aircraftcategory === "HELICOPTER") {
          let marker = ourMap.getOneMarkerByIcao(AircraftInfo.icao);
          this.turnCraftList.push(marker);
        } else if (AircraftInfo.icon === "helicopter") {
          let marker = ourMap.getOneMarkerByIcao(AircraftInfo.icao);
          this.turnCraftList.push(marker);
        }
      });
    },
    lightCraftListFun() {
      this.lightCraftList = [];
      this.aircraftInfos.forEach((AircraftInfo) => {
        if (AircraftInfo.aircraftcategory === "UNMANNEDAV") {
          let marker = ourMap.getOneMarkerByIcao(AircraftInfo.icao);
          this.lightCraftList.push(marker);
        } else if (AircraftInfo.icon === "Balloon") {
          let marker = ourMap.getOneMarkerByIcao(AircraftInfo.icao);
          this.lightCraftList.push(marker);
        }
      });
    },
    //清除大于10秒地图上的飞机
    clearCraftList() {
      this.aircraftInfos.forEach((newAircraftInfo) => {
        if (newAircraftInfo.latestTime - Date.now() < -10000) {
          newAircraftInfo.disappear();
          if (newAircraftInfo.isShowLabel) {
            newAircraftInfo.disappearLabel(newAircraftInfo.icao);
          }
          this.removeOldAircraftInfoByIcao(newAircraftInfo.icao);
        }
      });
    },

    //清除飞机实例列表
    removeOldAircraftInfoByIcao(icao) {
      this.aircraftInfos.forEach((newAircraftInfo, index) => {
        if (newAircraftInfo.icao === icao) {
          this.aircraftInfos.splice(index, 1);
        }
      });
    },

    async showPlan(aircraftInfo) {
      let res = await getflightplanbysn({ sn: aircraftInfo.sn });
      map.flyTo([aircraftInfo.alLatitude, aircraftInfo.alLongitude]);

      if (res) {
        this.stopDrawAction();
        res.roundareas.forEach((i) => {
          this.detailCir(i.id);
        });
        res.routes.forEach((i) => {
          this.detailLine(i.id);
        });
        res.polygonareas.forEach((i) => {
          this.detailSq(i.id);
        });
        this.initPlanshow(true);
        this.changeshowPlanInfo(res);
      } else {
        this.$alert("暂无查找到该计划", "提醒", {
          confirmButtonText: "确定",
        });
      }
    },
    showFunMeunBar(aircraftInfo) {
      this.changeshowFunMeunBarFLag(false);
      setTimeout(() => {
        this.changeshowFunMeunBarFLag(true);
      }, 100);

      this.changeshowFunMeunBar({ aircraftInfo, ourMap });
    },

    // 告警操作
    alarmCraftList(msg) {
      var alarmZoneList = msg.alarmZoneList;
      var alarmDistanceList = msg.alarmDistanceList;
      var alarmDisappearList = msg.alarmDisappearList;
      var alarmYawList = msg.alarmYawList;
      // alarmZoneList = [{ sourceIcao: "781a35" }];

      Object.values(this.adsbMap.iconGroup._layers).forEach((item) => {
        if (!item.type) {
          item.alarmZoneStr = "";
          item.alarmDistanceStr = "";
          item.alarmDisappearStr = "";
          item.alarmYawStr = "";
        }
      });

      //当前告警数组
      let arr = [];

      alarmZoneList.forEach((i) => {
        if (this.getOneMarkerByIcao(i.sourceIcao)[0]) {
          if (i.zoneType == "NOFLY") {
            this.getOneMarkerByIcao(i.sourceIcao)[0].alarmZoneStr = "禁飞区域";
          } else if (i.zoneType == "LIMITED") {
            this.getOneMarkerByIcao(i.sourceIcao)[0].alarmZoneStr =
              "不在计划区域";
          }
          arr.push({ icao: i.sourceIcao });
        }
      });

      alarmDistanceList.forEach((i) => {
        if (this.getOneMarkerByIcao(i.sourceIcao)[0]) {
          this.getOneMarkerByIcao(i.sourceIcao)[0].alarmDistanceStr =
            "距离告警";
          arr.push({ icao: i.sourceIcao });
        }
      });

      alarmDisappearList.forEach((i) => {
        if (this.getOneMarkerByIcao(i.sourceIcao)[0]) {
          this.getOneMarkerByIcao(i.sourceIcao)[0].alarmDisappearStr =
            "目标消失告警";
          arr.push({ icao: i.sourceIcao });
        }
      });

      alarmYawList.forEach((i) => {
        if (this.getOneMarkerByIcao(i.sourceIcao)[0]) {
          this.getOneMarkerByIcao(i.sourceIcao)[0].alarmYawStr = "偏航告警";
          arr.push({ icao: i.sourceIcao });
        }
      });

      this.currentAlarmArr = [];

      if (arr.length === 0) {
        audio.pause();
        Object.values(this.adsbMap.iconGroup._layers).forEach((e) => {
          e.alarmShow = false;
          this.aircraftInfos.forEach((AircraftInfo) => {
            if (!AircraftInfo.isStation) {
              AircraftInfo.alarmShow = false;
            }
          });

          if (e.setOpacity) {
            e._icon.style.color = "#fff";
            e.setOpacity(1);
          } else {
            e.setStyle({
              opacity: 1,
              fillOpacity: 1,
              color: "#9af8f8",
            });
          }
        });
      } else {
        audio.play();
        Object.values(this.adsbMap.iconGroup._layers).forEach((e) => {
          e.alarmShow = false;
          this.aircraftInfos.forEach((AircraftInfo) => {
            if (!AircraftInfo.isStation) {
              AircraftInfo.alarmShow = false;
            }
          });
        });
      }

      //告警总数组
      let allArr = [...Object.values(this.adsbMap.iconGroup._layers)];
      arr.forEach((i) => {
        allArr.forEach((e) => {
          let aircraftInfo =
            this.aircraftInfos[this.getAircraftInfoIndex(e.icao)];
          if (aircraftInfo.currentHeight) {
            if (i.icao === e.icao) {
              this.currentAlarmArr.push(e);
            }
          }
        });
      });

      this.currentAlarmArr.forEach((e) => {
        e.alarmShow = true;
        var aircraftInfoIndex = this.getAircraftInfoIndex(e.icao);
        let aircraftInfo = this.aircraftInfos[aircraftInfoIndex];
        aircraftInfo.alarmShow = true;
      });
    },

    setAlarmInterval() {
      var flag = 0;

      this.timer = setInterval(() => {
        if (!flag) {
          if (!this.currentAlarmArr) {
            return;
          }

          this.currentAlarmArr.forEach((e) => {
            if (e.setOpacity) {
              if (e._icon && e._icon.tagName == "DIV") {
                e._icon.style.color = "red";
              }

              e.setOpacity(1);
            } else {
              e.setStyle &&
                e.setStyle({
                  opacity: 1,
                  fillOpacity: 1,
                  color: "red",
                });
            }
          });
          flag = 1;
        } else {
          if (!this.currentAlarmArr) {
            return;
          }
          this.currentAlarmArr.forEach((e) => {
            if (e.setOpacity) {
              e.setOpacity(0);
            } else {
              e.setStyle &&
                e.setStyle({
                  opacity: 0,
                  fillOpacity: 0,
                  color: "#9af8f8",
                });
            }
          });
          flag = 0;
        }
      }, 499);
    },

    setIconInterval() {
      var flag = 0;
      this.IconTimer = setInterval(() => {
        if (!flag) {
          this.turnCraftList.forEach((marker) => {
            let my_icon = L.icon({
              iconUrl: "/image/helicopter1.png",
              iconSize: [35, 35],
              iconAnchor: [15, 15],
              tooltipAnchor: [20, 0],
            });
            marker.setIcon(my_icon);
          });
          this.lightCraftList.forEach((marker) => {
            let my_icon = L.icon({
              iconUrl: "/image/UAV1.png",
              iconSize: [25, 25],
              iconAnchor: [15, 15],
              tooltipAnchor: [20, 0],
            });
            marker.setIcon(my_icon);
          });

          flag = 1;
        } else {
          this.turnCraftList.forEach((marker) => {
            let my_icon = L.icon({
              iconUrl: "/image/helicopter2.png",
              iconSize: [35, 35],
              iconAnchor: [15, 15],
              tooltipAnchor: [20, 0],
            });
            marker.setIcon(my_icon);
          });
          this.lightCraftList.forEach((marker) => {
            let my_icon = L.icon({
              iconUrl: "/image/UAV3.png",
              iconSize: [25, 25],
              iconAnchor: [15, 15],
              tooltipAnchor: [20, 0],
            });
            marker.setIcon(my_icon);
          });
          flag = 0;
        }
      }, 500);
    },

    getOneMarkerByIcao(icao) {
      let markerOldLayer = Object.values(this.adsbMap.iconGroup._layers).filter(
        (i) => i.icao === icao
      );
      return markerOldLayer;
    },
  },
};
</script>

<style lang="less" scoped>
.adsb {
  display: flex;
  align-items: center;
  cursor: pointer;

  img {
    width: 35px;
    height: 35px;
  }
}
</style>